import { OfferCheckItem } from '@/views/processes/offer/util/offerChecklist.util.ts';

export enum OfferWizardStepEnum {
  CUSTOMER = 'customer',
  ELEMENTS = 'elements',
  EVENT = 'event',
  MENU = 'menu',
  PRICES = 'prices',
  REALIZATION = 'realization',
  SUMMARY = 'summary',
}

export const OFFER_WIZARD_STEPS: OfferWizardStepEnum[] = [
  OfferWizardStepEnum.CUSTOMER,
  OfferWizardStepEnum.EVENT,
  OfferWizardStepEnum.MENU,
  OfferWizardStepEnum.ELEMENTS,
  OfferWizardStepEnum.PRICES,
  OfferWizardStepEnum.REALIZATION,
  OfferWizardStepEnum.SUMMARY,
];

const EVENT_KEYS: string[] = ['groupDatesWithoutOfferDates', 'groupOutsideOfferDates'];

const PRICE_KEYS: string[] = [
  'discountAwaitingApproval',
  'discountRejected',
  'priceBelowMinimum',
  'warnings.setUnderpriced',
];

const stepByKey = (item: OfferCheckItem): OfferWizardStepEnum => {
  if (EVENT_KEYS.includes(item.key)) {
    return OfferWizardStepEnum.EVENT;
  }
  return PRICE_KEYS.includes(item.key) ? OfferWizardStepEnum.PRICES : OfferWizardStepEnum.MENU;
};

export const resolveOfferWizardStep = (item: OfferCheckItem): OfferWizardStepEnum => {
  switch (item.fix.kind) {
    case 'customer':
      return OfferWizardStepEnum.CUSTOMER;
    case 'distribute':
      return OfferWizardStepEnum.MENU;
    case 'element':
      return OfferWizardStepEnum.ELEMENTS;
    case 'eventDetails':
      return OfferWizardStepEnum.EVENT;
    case 'none':
      return stepByKey(item);
    case 'realizationContact':
      return OfferWizardStepEnum.REALIZATION;
    case 'reveal':
      return stepByKey(item);
    case 'selection':
      return OfferWizardStepEnum.MENU;
  }
};
